import React from 'react';

const customerPhotos = ['/customer1.jpg', '/customer2.jpg', '/customer3.jpg', '/customer4.jpg'];

const Customers = () => {
  const photoLoop = [...customerPhotos, ...customerPhotos];

  return (
    <section className="bg-white py-16 sm:py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-3 text-[#F59E0B]">
            <span className="h-[2px] w-8 bg-[#F59E0B]" />
            <span className="text-[11px] font-bold tracking-[0.25em]">OUR CUSTOMERS</span>
            <span className="h-[2px] w-8 bg-[#F59E0B]" />
          </div>
          <h2 className="mt-4 text-[#0B1220] font-extrabold tracking-tight" style={{ fontSize: 'clamp(2rem, 4vw, 3rem)' }}>
            Trusted by travellers &amp; locals in <span className="text-[#F59E0B]">Thamel</span> every day
          </h2>
        </div>
      </div>

      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-16 sm:w-32 bg-gradient-to-r from-white to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-16 sm:w-32 bg-gradient-to-l from-white to-transparent z-10" />
        <div className="group overflow-hidden">
          <div className="flex w-max gap-5 sm:gap-6 animate-marquee group-hover:[animation-play-state:paused]">
            {photoLoop.map((src, idx) => (
              <div key={`${src}-${idx}`} className="w-48 h-48 sm:w-64 sm:h-64 flex-shrink-0 rounded-2xl overflow-hidden shadow-md ring-2 ring-[#F59E0B]/20">
                <img src={src} alt="Customer at Ace Money Exchange, Thamel" className="w-full h-full object-cover" loading="lazy" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Customers;
